<template>
	<div class="modal fade" role="dialog" aria-labelledby="closeTareasOportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="closeTareasOportunidadLabel">
						Tareas asociadas a la oportunidad
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body p-0">
					<preloader v-if="loading"></preloader>
					<div v-show="showIndex">
						<div v-if="tareas.length>0" class="m-3">
							<a href="#" class="btn btn-success mb-3" v-tooltip="'Agregar Tarea'"  data-toggle="tooltip" data-placement="bottom" v-on:click.prevent="addTareas">
	                        	<i class="material-icons">add</i> Agregar Tarea
	                        </a>
	                        <button class="btn btn-primary mb-3" v-on:click="getTareas" v-tooltip="'Actualizar'">
								<i class="material-icons">refresh</i>
							</button>
	                        <button type="button" class="btn btn-danger mb-3 float-right" v-tooltip="'Cerrar Tareas'" data-toggle="tooltip" data-placement="bottom" v-on:click="closeAll" v-if="showCloseAll">
		                    	<i class="material-icons">not_interested</i> Cerrar Todas
		                    </button>

	                        <div class="list-group">
						    	<div class="flex-column align-items-start list-group-item list-group-item-action" v-for="(tarea, index) in tareas">
									<div class="d-flex w-100 justify-content-between">
								  		<div v-bind:class="{'mb-1':true, 'text-black-38':tarea.ESTATUS=='C'}">
									  		<h5 class="m-0">
									  			<small v-bind:class="{'badge':true, 'badge-info':tarea.ESTATUS=='A', 'badge-danger':tarea.ESTATUS=='C'}">
							  						{{formatDate(tarea.FECHA)}}	
							  					</small> | {{tarea.TIPO_TAREA}}
									  		</h5>
								  			<p v-bind:class="{'mb-0':true, 'text-black-38':tarea.ESTATUS=='C', 'text-muted':tarea.ESTATUS!='C'}">
												{{tarea.NOTAS}}
											</p>
								  		</div>
								  		<span class="text-dark" v-if="tarea.ESTATUS!='C'">
								  			<button 
												type="button" 
												class="btn btn-danger" 
												v-tooltip="'Cerrar Tarea'" 
												data-toggle="tooltip" 
												data-placement="bottom" 
												v-on:click="closeTarea(tarea.CODIGO_TAREA)">
					                        	<i class="material-icons">not_interested</i>
					                        </button>
								  		</span>
									</div>
								</div>
							</div>
						</div>
						<empty icon="event" title="Agregar Tareas" description="Para poder visualizar el listado de las Tareas debes agregar una nueva." v-if="tareas.length<=0 && !loading">
							<a href="#" class="btn btn-success" v-tooltip="'Agregar Tarea'"  data-toggle="tooltip" data-placement="bottom" v-on:click.prevent="addTareas">
	                        	<i class="material-icons">add</i> Agregar Tarea
	                        </a>
						</empty>
					</div>
					<div v-show="!showIndex" class="p-3">
						<div class="row">
							<div class="col-md-8">
								<icon-group class="mb-3" icon="filter_list" title="Tipo Tarea">
									<label>Tipo de Tarea:</label>
									<catalogo-tipos-tareas 
										v-model="form.tipoTarea"
										:disabled="disabled">
					      			</catalogo-tipos-tareas>
	                            	<div 
	                            		class="text-danger" 
	                            		v-if="errors.tipo_tarea">
	                            		{{errors.tipo_tarea[0]}}
	                            	</div>
								</icon-group>

								<icon-group class="mb-3" title="Fecha" icon="query_builder">
						      		<datetime 
						      			v-model="form.fecha"
						      			:disabled="disabled"></datetime>
				      				<div 
				      					class="text-danger" 
				      					v-if="errors.fecha">
				      					{{errors.fecha[0]}}
				      				</div>
						      	</icon-group>

						      	<icon-group class="mb-3" icon="person" title="Usuario Asignado">
						      		<label>Usuario:</label>
						      		<catalogo-usuarios 
						      			v-model="form.usuarios"
						      			:disabled="disabled"></catalogo-usuarios>
	                            	<div 
	                            		class="text-danger" 
	                            		v-if="errors.usuario_asignado">
		                            	{{errors.usuario_asignado[0]}}
		                            </div>
						      	</icon-group>
						    </div>
						      	
							<div class="col-md-4">
								<icon-group class="mb-3" icon="note" title="Notas">
				      				<textarea 
				      					class="form-control" 
				      					placeholder="Notas" 
				      					v-model="form.notas"
				      					:disabled="disabled"></textarea>
				      				<div 
				      					class="text-danger" 
				      					v-if="errors.notas">
		                            	{{errors.notas[0]}}
		                            </div>
						      	</icon-group>
								<icon-group class="mb-3" icon="group_add" title="Invitados">
						      		<catalogo-correos v-model="form.invitados"></catalogo-correos>
						      		{{form.invitados}}
				                    <div class="text-danger" v-if="errors.emails">
		                            	{{errors.emails[0]}}
		                            </div>
						      	</icon-group>
							</div>
						</div>
						<div class="text-right p-3">
							<a href="#" class="btn btn-secondary" v-on:click.prevent="cancelForm">
								Volver al listado
							</a>
							<a href="#" class="btn btn-success" v-on:click.prevent="storeTareas">
								Crear
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['oportunidad'],

		data(){
			return {
				loading: false,
				showIndex: true,
				disabled: false,
				showCloseAll: true,

				tareas:[],
				form: {
					tipoTarea: '',
					fecha: moment().add(5, 'd').format("DD-MM-YYYY HH:00:00"),
					usuarios: '',
					notas: '',
					estatus: '',
					invitados: ''
				},
				errors: {}
			}
		},

		mounted(){
			this.loading = true;
			this.showIndex = true;
			var vm = this;
			$(this.$el).on('shown.bs.modal', function () {
				vm.showIndex = true;
				vm.getTareas();	
			});
		},

		methods: {
			getTareas: function(){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/tareas';

				axios.get(url)
				.then(response => {
					this.tareas = response.data;
				}).catch(error => {
					console.log(error);
				}).then(()=>{
					this.loading = false;
				});
			},

			addTareas: function(){
				this.showIndex = false;
			},

			storeTareas: function(){
				var url = 'api/tareas';
				this.loading = true;

		    	axios.post(url, {
		    		fecha: this.form.fecha,
		    		tipo_tarea: this.form.tipoTarea,
		    		oportunidades: this.oportunidad,
		    		usuario_asignado: this.form.usuarios,
		    		notas: this.form.notas,
		    		invitado: this.form.invitados,
		    	})
		    	.then(response => {
		    		this.$toasted.show('Tarea agregada');
		    		this.getTareas();
		    		this.showIndex = true;
		    	}).catch(error=>{
		    		console.log(error.response);
		    		this.$toasted.show('Error al agregar tarea.');
		    		if (error.response.status == 422 & typeof(error.response.data.errors) != "undefined") {
                        this.errors = error.response.data.errors;
                    }
		    	}).then(()=>{
		    		this.loading = false;
		    	});
			},

			cancelForm: function(){
				this.showIndex = true;
			},

			closeAll: function(){
				var tareas = this.tareas
								.filter(tarea => tarea.ESTATUS != 'C')
								.map(tarea => tarea.CODIGO_TAREA);
				this.close(tareas);
			},

			closeTarea: function(value){
				this.close([value]);
			},

			close: function(values){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/tareas/cerrar';
				var vm = this;
				$.confirm({
                    title: '¿Estás seguro?',
                    content: '¡Ya no podrás recuperar esta información!',
                    theme: 'supervan', // 'material', 'bootstrap'
                    buttons: {
                        Confirmar: function () {
                            axios.put(url, {
								tareas: values
							})
							.then(response => {
								vm.$toasted.show(response.data);
								vm.getTareas();
							}).catch(error => {
								console.log(error.response);
								vm.$toasted.show('Error al Cerrar Tareas. Intente más tarde.');
							}).then(()=>{
								vm.loading = false;
							});
                        },
                        Cancelar: function () {
                        },
                    }
                });
			},

			cleanFields: function(){
				this.form.tipoTarea = '';
				this.form.fecha = moment().add(5, 'd').format("DD-MM-YYYY HH:00:00");
				this.form.usuarios = '';
				this.form.notas = '';
				this.form.estatus = '';
				this.form.invitados = '';
			},

			formatDate: function(date){
				return moment(date).format("DD-MM-YYYY HH:mm");
			}
		},

		watch: {
			showIndex: function(val){
				if (val == true) {
					this.cleanFields();
				}
			},

			tareas: function(val){
				if(val.filter(tarea => tarea.ESTATUS == 'C').length == val.length){
					this.showCloseAll = false;
				}else{
					this.showCloseAll = true;
				}
			}
		}
	}
</script>